// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
import "../scss/style.scss";
// import './isi.js';
// import './scroll-hero.js'
// import './header'
// import './video-playlist'

// const isDiviVisualBuilder = () => {
//   return (
//     window.et_fb ||
//     window.ET_Builder ||
//     document.body.classList.contains("et-fb") ||
//     document.body.classList.contains("et_fb") ||
//     window.location.href.includes("et_fb=1") ||
//     window.location.href.includes("et-bfb") ||
//     typeof window.ET_Builder !== "undefined"
//   );
// };

document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("load", () => {
    document.body.classList.add("loaded");
  });
  let canScrollToTopOnResize = false;

  let insideDiviBuilder =
    window.top?.et_builder_utils_params?.builderType === "vb"; //fe for non builder mode

  // Only load ISI script if not in Divi Visual Builder
  if (!insideDiviBuilder) {
    console.log("✅ Not inside Divi Visual Builder");
    import("./isi.js")
      .then(() => {
        console.log("ISI script loaded");
      })
      .catch((err) => {
        console.warn("Failed to load ISI script:", err);
      });

    import("./header.js")
      .then(() => {
        console.log("Header script loaded");
      })
      .catch((err) => {
        console.warn("Failed to load Header script:", err);
      });

    import("./modal-simple.js")
      .then(() => {
        console.log("Modal script loaded");
      })
      .catch((err) => {
        console.warn("Failed to load Modal script:", err);
      });

    import("./anchor-links.js")
      .then(() => {
        console.log("Anchor links script loaded");
      })
      .catch((err) => {
        console.warn("Failed to load Anchor links script:", err);
      });
  } else {
    console.log("❌ Skipping ISI script, Inside Divi Visual Builder");
  }

  console.log("palsonify theme", "v1.0.0");

  const scrollToTop = (iframe) => {
    if (!iframe) return;

    const iframeTop = window.scrollY + iframe.getBoundingClientRect().top;
    const scrollTarget = Math.max(iframeTop - 100, 0);

    console.log("[Parent] scrolling iframe into view");
    window.scrollTo({
      top: scrollTarget,
      behavior: "smooth",
    });

    iframe.focus({ preventScroll: true });
  };

  setTimeout(() => {
    canScrollToTopOnResize = true;
  }, 5000);

  // Prevent cookie banner from being dismissed on outside click
  // document.addEventListener("click", (e) => {
  //   const banner = document.getElementById("onetrust-banner-sdk");
  //   const prefCenter = document.getElementById("onetrust-pc-sdk");
  //   if (!banner && !prefCenter) return;

  //   const insideBanner = banner && banner.contains(e.target);
  //   const insidePrefCenter = prefCenter && prefCenter.contains(e.target);

  //   if (!insideBanner && !insidePrefCenter && (banner || prefCenter)) {
  //     e.stopPropagation();
  //   }
  // }, true);

  const iframe = document.getElementById("jd-iframe-form");

  if (!iframe) return;

  window.addEventListener("message", ({ data, source }) => {
    if (source !== iframe.contentWindow || !data?.type) return;

    if (data.type === "resize") {
      iframe.style.height = `${data.height}px`;

      if (canScrollToTopOnResize) scrollToTop(iframe);
    }

    if (data.type === "success") {
      iframe.classList.add("form-submitted");
      scrollToTop(iframe);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "cloudpage_form_success",
        form_name: "Salesforce CloudPage form",
        form_id: "salesforce_cloudpage_form",
      });
    }
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//   const el = document.querySelector(".footer-cookie-link.ot-sdk-show-settings");
//   if (!el) return;

//   const setText = () => { el.textContent = "Cookie Policy"; };

//   // set once immediately
//   setText();

//   // and again after OneTrust potentially overwrites
//   setTimeout(setText, 5);
//   setTimeout(setText, 15);
// });
